export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
export const EMAIL = "email";
export const KEYROCK_TOKEN = "keyrockToken";
export const FUNCIONALIDAES = "funcionalidades";
